/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillScope
*/
export var SkillScope;
(function (SkillScope) {
    SkillScope["USER"] = "USER";
    SkillScope["PROJECT"] = "PROJECT";
    SkillScope["VANCE"] = "VANCE";
    SkillScope["RESOURCE"] = "RESOURCE";
})(SkillScope || (SkillScope = {}));
//# sourceMappingURL=SkillScope.js.map